module.exports = __webpack_public_path__ + "static/media/sensor7.83ea9c2b.jpg";